<template>
    <div class="admin-city-screen-wrapper">
        <h2>Add Location Data</h2>
        <div class="admin-city-input-section" align="center">
            <WorldCitySearch :searchMode="'google-lookup'" :textFieldSize="300" :criteria="criteria" @selectedWorldCity="setWorldCity"></WorldCitySearch>                    
        </div>
        <div class="locations">
            <div class="new-location-data" align="center">
                <table border="1" cellpadding="10" width="100%">
                    <tr>
                        <td width="25%">Id</td>
                        <td width="75%"><b>Google Places</b></td>
                    </tr>
                    <tr>
                        <td width="25%">Location</td>
                        <td width="75%"><b>{{newLocation.city}}</b></td>
                    </tr>
                    <tr>
                        <td width="25%">Latitude</td>
                        <td width="75%"><b>{{newLocation.lat}}</b></td>
                    </tr>
                    <tr>
                        <td width="25%">Longitude</td>
                        <td width="75%"><b>{{newLocation.lng}}</b></td>
                    </tr>
                    <tr>
                        <td width="25%">TimeOffset</td>
                        <td width="75%"><b>{{newLocation.timeOffset}}</b>   </td>
                    </tr>
                    <tr>
                        <td width="25%">TimeZone</td>
                        <td width="75%"><b>{{newLocation.timezone}}</b></td>
                    </tr>
                    <tr>
                        <td colspan="2" width="100%" align="center">
                            <img :src="getNewLocationMapUrl()"/>                                                                               
                        </td>
                    </tr>
                    <tr v-if="newLocation.city != 'Tiruvannamalai, Tamil Nadu, India'">
                        <td colspan="2" width="100%" align="center">
                            <button @click="addCity()" 
                                style="height:30px;background-color:#087F8C;color:white">&nbsp;Add this Location&nbsp;</button>                            
                        </td>
                    </tr>
                </table>
            </div>
            <div class="existing-location-data" align="center" v-if="existingLocation.city">
                <table border="1" cellpadding="10" width="100%">        
                    <tr>
                        <td width="25%">Id</td>
                        <td width="75%"><b>{{existingLocation.id}}</b></td>
                    </tr>
                    <tr>
                        <td width="25%">Location</td>
                        <td width="75%"><b>{{existingLocation.city}}</b></td>
                    </tr>
                    <tr>
                        <td width="25%">Latitude</td>
                        <td width="75%"><b>{{existingLocation.lat}}</b></td>
                    </tr>
                    <tr>
                        <td width="25%">Longitude</td>
                        <td width="75%"><b>{{existingLocation.lng}}</b></td>
                    </tr>
                    <tr>
                        <td width="25%">TimeOffset</td>
                        <td width="75%"><b>{{existingLocation.timeOffset}}</b>   </td>
                    </tr>
                    <tr>
                        <td width="25%">TimeZone</td>
                        <td width="75%"><b>{{existingLocation.timezone}}</b></td>
                    </tr>
                    <tr>
                        <td colspan="2" width="100%" align="center">
                            <img :src="getExistingLocationMapUrl()"/>                                                                               
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" width="100%" align="center">
                            <button @click="removeCity()" 
                                style="height:30px;background-color:#087F8C;color:white">&nbsp;Remove this Location&nbsp;</button>                            
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import HTTP from "../http-axios";
import { queryString } from "../util.js";
import GoogleAPICredentials from "../google-api-credentials";
import WorldCitySearch from "@/components/widget-city-search/WorldCitySearch.vue";

export default {
  components: { WorldCitySearch },
  data() {
        return {
            criteria: {
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1,
                day: new Date().getDate(),
                hour: new Date().getHours(),
                minute: new Date().getMinutes(),
                second: 0,

                location: "Tiruvannamalai, Tamil Nadu, India",
                latitude: 12.2253,
                longitude: 79.0747,
                timeOffset: 5.5,
                timeOffsetMinutes: 330,
            },
            newLocation: {
                id: 0,
                city: "Tiruvannamalai, Tamil Nadu, India",
                lat: 12.2253,
                lng: 79.0747,
                timezone: "Asia/Calcutta",
                timeOffset: 5.5,
            },
            existingLocation: {
                id: 0,
                city: "",
                lat: 0.0,
                lng: 0.0,
                timezone: "",
                timeOffset: 0.0,
            },
            timezoneData: {},
        }
  },
  created() {
  },
  mounted() {
  },

  methods: {
        setWorldCity: function (worldCity) {
            this.newLocation.city = worldCity.city;
            this.newLocation.lat = worldCity.lat;
            this.newLocation.lng = worldCity.lng;
            this.newLocation.timezone = worldCity.timezone;
            this.newLocation.timeOffset = worldCity.timeOffset;

            // debug
            // console.log('awcloc: ' + this.newLocation.city)
            // console.log('awclat: ' + this.newLocation.lat)
            // console.log('awclng: ' + this.newLocation.lng)
            // console.log('awctz: '  + this.newLocation.timezone)
            // console.log('awctoff: ' + this.newLocation.timeOffset)

            // Get Existing Locations
            this.getExistingLocations();

        },
        getGoogleAPICredentials: function () {
            return GoogleAPICredentials();
        },
        getNewLocationMapUrl: function () {
            //return "https://www.google.com/maps/embed/v1/place?q=" + this.newLocation.city + "&zoom=8&maptype=roadmap" + "&key=" + this.getGoogleAPICredentials();
            return 'https://maps.googleapis.com/maps/api/staticmap?center=' + 
                                this.newLocation.lat +  ',' + this.newLocation.lng + 
                                '&zoom=10&size=300x300&maptype=roadmap' + 
                                '&markers=size:mid|color:red|' + this.newLocation.lat +  ',' + this.newLocation.lng + 
                                '&key=' + this.getGoogleAPICredentials();
        },
        getExistingLocationMapUrl: function () {
            //return "https://www.google.com/maps/embed/v1/place?q=" + this.newLocation.city + "&zoom=8&maptype=roadmap" + "&key=" + this.getGoogleAPICredentials();
            return 'https://maps.googleapis.com/maps/api/staticmap?center=' + 
                                this.existingLocation.lat +  ',' + this.existingLocation.lng + 
                                '&zoom=10&size=300x300&maptype=roadmap' + 
                                '&markers=size:mid|color:red|' + this.existingLocation.lat +  ',' + this.existingLocation.lng + 
                                '&key=' + this.getGoogleAPICredentials();
        },
        getTimeStamp() {
            return Date.now() / 1000 | 0;
        },
        getExistingLocations: function() {
            HTTP().post(`/api/data/city/lookup?input=` + this.newLocation.city)
            .then(response => {
                var cities = response.data
                // console.log('cities: ' + JSON.stringify(cities))

                // If uniquely matching city available
                if ( cities && cities.length == 1) {
                    // console.log('cities[0]: ' + JSON.stringify(cities[0]))
                    this.existingLocation.id = cities[0].id
                    this.existingLocation.city = cities[0].city
                    this.existingLocation.lat = cities[0].lat
                    this.existingLocation.lng = cities[0].lng
                    this.existingLocation.timezone = cities[0].timezone
                    this.existingLocation.timeOffset = cities[0].timeOffset
                } else {
                    this.existingLocation = {};
                }

            })
            .catch(e => {
                console.log(e)
            })
        },
        queryString: function (obj) {
            return queryString(obj);
        },
        addCity: function () {
            HTTP()
                .post(`/api/data/city/add?` + this.queryString(this.newLocation))
                .then((response) => {

                    // console.log('success: ADD city : ' + JSON.stringify(this.newLocation))

                    // Show newly added location on screen
                    this.getExistingLocations();
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        removeCity: function () {
            HTTP()
                .post(`/api/data/city/remove?` + this.queryString(this.existingLocation))
                .then((response) => {

                    // console.log('success: REMOVE city : ' + JSON.stringify(this.existingLocation))

                    // Search for recently removed location
                    this.getExistingLocations();

                })
                .catch((e) => {
                    console.log(e);
                });
        },
  }

}

</script>

<style scoped>

.admin-city-screen-wrapper {
  border: 0px solid;
  width: 720px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
}

.admin-city-input-section {
  border: 0px solid;
  width: 100%;
  margin-top: 10px;
}

.locations {
  width: 100%;
  border: 0px solid;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.new-location-data {
    margin-top: 30px;
    margin-bottom: 15px;
    width: 350px;
}

.existing-location-data {
    margin-top: 30px;
    margin-bottom: 15px;
    width: 350px;
}

table, th, td {
  border: 1px solid #cccccc;
  border-collapse: collapse;
  font-family: sans-serif;
  font-size: 14px;
}

input[type=text] {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;  
  padding: 15px 15px;
  margin: 2px 0;
  box-sizing: border-box;
  border: 2px solid #087F8C;
  -webkit-transition: 0.5s;
  transition: 0.2s;
  outline: none;
}

input[type=text]:focus {
  border: 2px solid #ACD8AA;
}

button {
  background-color: #FBFBFF;
  color: #087F8C;
  font-weight: bold;
  border: none;
  padding: 5px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  cursor: pointer;
  border-radius: 5px;
  outline: none;
  text-align: center;
}

@media screen and (max-width: 725px) {

    .admin-city-screen-wrapper {
        border: 0px solid;
        width: 350px;
        margin: 10px auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .locations {
        border: 0px solid;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }

    .new-location-data {
        margin-top: 10px;
        margin-bottom: 15px;
        width: 350px;
    }

    .existing-location-data {
        margin-top: 10px;
        margin-left: 0px;
        margin-bottom: 15px;
        width: 350px;
    }

}

</style>